var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('con-tab'),_c('home-hospital',{staticClass:"nei_box"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }